export default __webpack_public_path__ + "static/media/partners11.bcf99cc7.png";